import React, { useEffect, useState } from "react";
import * as d3 from "d3";
import { useGetConceptsFiltersMutation } from "../../../store/api/lumi/concepts";
import { Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { getConceptFilter } from "../../../utils/getConceptFilter";
import { debounce } from "lodash";
import Scrollbars from "react-custom-scrollbars-2";
import classes from "../VolumeDaylightWidget/VolumeDaylightWidget.module.css";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import VolumeSummary from "./VolumeSummary";

export function VolumeDaylightWidget(props) {
    const [modifiedData, setModifiedData] = useState([]);
    const [isLoading, seIstLoading] = useState(false);
    const [getVolumes] = useGetConceptsFiltersMutation();
    const [selectedConcept, setSelectedConcept] = useState(null);
    const { id } = useParams();
    const sentiment_share_ai = useSelector(state => state.auth.flags.sentiment_share_ai);

    const labelFontSize = useSelector((state) => {
        const fontSizes = state.fontManager.fontSizes;
        const normalizedKey = Object.keys(fontSizes).find(
            (key) => key.trim() === "labelFontSize",
        );
        return fontSizes[normalizedKey] || 16;
    });

    async function getVolume() {
        seIstLoading(true);
        const conceptFilter = getConceptFilter(props);

        const { data: dataConcepts } = await getVolumes({
            id: props.id,
            concept_selector: conceptFilter,
            filter: props.filters,
        });
        let results = dataConcepts.match_counts;
        if (props && props.conceptList) {
            props.setLocalConceptOptions(results);
        }
        props.setFilterDocCount(dataConcepts.filter_count);
        const aggregatedData = Array.from(
            d3.rollup(
                results,
                (group) => {
                    const total_count = group[0].match_count;
                    const exact_match_count = group[0].exact_match_count;
                    const conceptual_match_count = total_count - exact_match_count;
                    return {
                        concept: group[0].name,
                        texts: group[0].texts,
                        exact_match_count: exact_match_count,
                        conceptual_match_count: conceptual_match_count,
                        total_count: total_count,
                        exact_match_percentage: (exact_match_count / total_count) * 100,
                        conceptual_match_percentage: (conceptual_match_count / total_count) * 100,
                    };
                },
                (d) => d.name,
            ).values(),
        );

        const sortedData = aggregatedData.sort(
            (a, b) => b.total_count - a.total_count,
        );
        setSelectedConcept(sortedData[0])
        seIstLoading(false);
        setModifiedData(sortedData);
    }

    useEffect(() => {
        seIstLoading(true);
        const debouncedGetVolume = debounce(getVolume, 500);

        debouncedGetVolume();

        return () => {
            debouncedGetVolume.cancel();
        };
    }, [
        props.selectedPageSize,
        props.filters,
        props.conceptTypeDay,
        props.selectedLocalConcepts,
        props.conceptList,
    ]);

    if (isLoading) {
        return (
            <Spin
                className={"spinner-by-center"}
                indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
            />
        );
    }
    const defaultHeight = props.widget.layout.h * 39 - 200;

    return (
        <div>
            <div style={{ justifyContent: "flex-start", padding: "10px" }}>
                <div className="sentiment exact">
                    <div className="color-box"></div>
                    Exact Matches
                </div>
                <div className="sentiment conceptual">
                    <div className="color-box"></div>
                    Conceptual Matches
                </div>
            </div>
            <div style={{ padding: "0 10px" }}>
                <div className={classes.change_type}>
                    <div className={classes.gridHeader}>
                        <div className={classes.headerGridContainer}>
                            <div className={classes.gridItemHeader}>Concept</div>
                            <div className={classes.gridItemHeader}>Total Matches</div>
                            <div className={classes.gridItemHeader}></div>
                        </div>
                    </div>
                </div>
                <div>

                    <Scrollbars style={{ height: defaultHeight }}>
                        <div className={classes.gridContainer}>
                            {modifiedData.map((concept, index) => (
                                <div key={concept.concept + index} className={classes.gridRow}>
                                    <div style={{ fontSize: labelFontSize, cursor: "pointer" }}
                                         className={classes.gridItemConcept}
                                         onClick={() => setSelectedConcept(concept)}
                                         onMouseDown={e => e.stopPropagation()}
                                    >{concept.concept}
                                    </div>
                                    <div style={{ fontSize: labelFontSize }}
                                         className={classes.gridItemConcept}>
                                        {concept.total_count}
                                    </div>

                                    <div className={classes.gridItemConcept}>
                                        <div className={classes.barContainer}>
                                            <div
                                                className={classes.exactMatchBar}
                                                style={{
                                                    width: `${concept.exact_match_percentage}%`,
                                                }}
                                                title={`Exact Matches: ${concept.exact_match_count} (${concept.exact_match_percentage.toFixed(1)}%)`}
                                            />
                                            <div
                                                className={classes.conceptualMatchBar}
                                                style={{
                                                    width: `${concept.conceptual_match_percentage}%`,
                                                }}
                                                title={`Conceptual Matches: ${concept.conceptual_match_count} (${concept.conceptual_match_percentage.toFixed(1)}%)`}
                                            />
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                        {sentiment_share_ai && <VolumeSummary id={id} selectedConcept={selectedConcept} />}
                    </Scrollbars>
                </div>
            </div>
        </div>
    );
}
